import {_serializeSingle, _serializeList} from '../core';
import type {ServerData} from '../core';
import type {DomainOf} from '../../../../types/domain';
import type {WithDocumentLabels} from '../_extras';
import {serializeDocumentLabelList} from './participant';

/** 스키마 밖에서 조립되는 관계 필드 — 서버 응답 계약의 일부. */
type DocumentSealBffExtras = WithDocumentLabels;

export function serializeDocumentSeal(data: ServerData) {
    return _serializeSingle("documentSeal", data);
}

export function serializeDocumentSealList(data: ServerData) {
    return _serializeList("documentSeal", data);
}

export function serializeDocumentSealBff(data: ServerData) {
    if (!data) return null;
    const documentSeal: DomainOf<"documentSeal"> & DocumentSealBffExtras = _serializeSingle("documentSeal", data);
    if (data.documentLabels) {
        documentSeal.documentLabels = serializeDocumentLabelList(data.documentLabels);
    }
    return documentSeal;
}

export function serializeDocumentSealBffList(data: ServerData) {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => serializeDocumentSealBff(item));
}
